.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: rgba(54, 123, 255, 0.08);
  border: 0.2rem dashed #367bff;
  border-radius: 0.5rem;
}

.title {
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #ffffff;
  margin-top: 0.5rem;
  margin-bottom: 2.4rem;
}
